import { call, put } from 'redux-saga/effects';
import { rejectActionPromise } from '../../../utils/rejectActionPromise';
import { resolveActionPromise } from '../../../utils/resolveActionPromise';
import { loadFileByUrlFailed, loadFileByUrlSuccessful } from '../actions';
import makeRequest from '../../../utils/makeRequest';
import { OK } from '../../../configs/serverStatusCodes';
import processError from '../../../utils/processError';

export default function* loadFileByUrl(action) {
  try {
    const link = action.payload;
    const pool = {};
    const dataResponse = yield makeRequest(link, pool, action, 'GET');
    if (dataResponse.status === OK) {
      const data = yield dataResponse.blob();
      yield put(loadFileByUrlSuccessful());
      yield call(resolveActionPromise(action, data));
    } else {
      yield put(loadFileByUrlFailed());
      yield call(rejectActionPromise(action));
    }
  } catch (e) {
    yield put(loadFileByUrlFailed([]));
    yield call(rejectActionPromise(action, {}));
    yield processError(e);
  }
}
